<template>
  <div id="gamescores">
    <div id="content">
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-gamepad"></i> Mini-Jeu Weezy
        </h1>
      </div>
    </div>
    <gameScoresTable
      id="gameScoresTable"
      :scores="scores"
      :users="users"
    />
  </div>

</template>

<script>
import gameScoresTable from "@/components/gameScoresTable";
import http from "@/modules/request";

export default {
  name: "sales",
  components: {
    gameScoresTable
  },
  data() {
    return {
      scores: [],
      users: []
    };
  },
  mounted() {
    this.$parent.$refs.menubar.login = true;
    this.getUsers();
    this.getScores();
  },
  methods: {
    isAdmin() {
      return this.$store.state.role == "admin";
    },
    getUsers() {
      http
        .get("/users")
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getScores() {
      http
        .get("/scores")
        .then(response => {
          this.scores = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}
</style>